import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=3e340aaf&functional=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=ts&"
export * from "./BaseInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports